<template>
  <ul ref="catalogRef" class="com-catalogs">
    <li v-for="(item, index) in data" :key="index" :class="['com-catalogs-item', item.open && 'open']">
      <div
        v-show="item.url || item.children?.length"
        :class="['com-catalogs-header', item.url === url && `is__active`]"
      >
        <button
          :class="[
            'com-catalogs-toggle-button',
            item.open && 'open',
            item.children && item.children?.length > 0 ? 'visible' : 'hidden'
          ]"
          @click="toggleCatalogs(item)"
        >
          <svg :class="['com-catalogs-icon']" viewBox="0 0 10 7" fill="#C8CCD3" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5 7L0 2.1V1.66893e-06H10V2.1L5 7Z" />
          </svg>
        </button>
        <div class="com-catalogs-title" :title="item.title">
          <NuxtLink
            v-if="item.url"
            :to="`/${$route.params.lang}/docs/${item.url}`"
            class="com-catalogs-name-txt com-catalogs-name-link"
            @click="openCatalogs(item)"
          >
            {{ item.title }}
          </NuxtLink>
          <span v-else class="com-catalogs-title-ctx" @click.stop="openCatalogsDocument(item)">{{ item.title }} </span>
        </div>
      </div>
      <template v-if="item.children">
        <CommonCatalogs
          v-show="item.open"
          :url="url"
          :class="['com-catalogs-child', item.open && 'is__active']"
          :data="item.children"
        />
      </template>
    </li>
  </ul>
</template>
<script lang="ts" setup>
interface CatalogsConfig {
  id: number
  title: string
  url?: string
  open?: boolean
  obsoleted?: boolean
  children?: CatalogsConfig[]
}
defineProps<{
  data: CatalogsConfig[]
  url?: string
}>()
const route = useRoute()
const catalogRef = ref()
const toggleCatalogs = (item: CatalogsConfig) => {
  item.open = !item.open
}
const openCatalogsDocument = (item: CatalogsConfig) => {
  item.open = true
  const doc = findChildrenDocument(item.children || [], 'url')
  doc && navigateTo(`/${route.params.lang}/docs/${doc.url}`)
}
const findChildrenDocument = (arr: CatalogsConfig[], key = 'url'): CatalogsConfig | undefined => {
  for (const item of arr) {
    if (item[key as keyof CatalogsConfig]) {
      return item
    } else if (item.children) {
      return findChildrenDocument(item.children, key)
    }
  }
  return undefined
}
const openCatalogs = (item: CatalogsConfig) => {
  item.open = true
}
</script>
<style lang="scss" scoped>
.com-catalogs {
  color: #fff;
  transition: 0.3s ease;
  padding: 0 0 0 20px;
  .com-catalogs {
    will-change: height;
    padding: 0 0 0 10px;
  }
}
.com-catalogs-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  transition: 0.3s ease;
  transition-property: opacity, height;
  font-size: 16px;
  height: 30px;
  color: #c8ccd3;
  line-height: 30px;

  .com-catalogs-name-link {
    transition: 0.3s;
  }
  &.is__active {
    .com-catalogs-name-link {
      color: #ffba00;
    }
    .com-catalogs-icon {
      fill: #ffba00;
    }
    &:after {
      content: '';
      position: absolute;
      z-index: -1;
      right: 0;
      bottom: 0;
      width: 340px;
      height: 100%;
      background-color: #363a41;
    }
  }
}

.com-catalogs-title {
  position: relative;
  max-width: 100%;
  //overflow: hidden;
  cursor: pointer;
  text-indent: 10px;
  //margin-left: 20px;
}
.com-catalogs-name-txt {
  display: block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.com-catalogs-toggle-button {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10px;
  height: 10px;
  margin: 1px 0 0 0;
  transition: transform 0.3s;
  transform: rotate(-90deg);
  &.open {
    transform: rotate(0);
  }
  &.visible {
    visibility: visible;
  }
  &.hidden {
    visibility: hidden;
  }
  &:after {
    content: '';
    position: absolute;
    width: 200%;
    height: 200%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
  }
}
.com-catalogs-icon {
  flex-shrink: 0;
  width: 10px;
  height: 7px;
}
@media not all and (hover: none) {
  .com-catalogs-name-link:hover {
    color: #ffba00;
  }
  //.com-catalogs-title {
  //  &:hover {
  //    &::after {
  //      display: inline-block;
  //    }
  //  }
  //}
}
//@media screen and (min-width: 1024px) {
//  .com-catalogs-title {
//    &:after {
//      content: attr(data-title);
//      position: absolute;
//      top: 110%;
//      left: 0;
//      z-index: 1;
//      color: #000;
//      min-width: 80px;
//      max-width: 160px;
//      text-align: center;
//      background-color: #d2d2d2;
//      font-size: 12px;
//      padding: 2px 6px;
//      line-height: normal;
//      display: none;
//    }
//  }
//}
@media not all and (min-width: 1024px) {
  .com-catalogs {
    padding-left: 36px;
    .com-catalogs {
      padding-left: 16px;
    }
  }
  .com-catalogs-header {
    font-size: 28px;
    line-height: 38px;
    height: 60px;
    &.is__active {
      &:after {
        width: 686px;
      }
    }
  }
  .com-catalogs-title {
    text-indent: 20px;
  }
  .com-catalogs-icon {
    width: 20px;
    height: 16px;
  }
  .com-catalogs-toggle-button {
    width: 16px;
    height: 16px;
    margin: 2px 0 0 0;
  }
  @media screen and (orientation: landscape) {
    .com-catalogs-header {
      &.is__active {
        &:after {
          width: 100vw;
        }
      }
    }
  }
}
</style>
